import React from 'react';
import proptypes from 'prop-types';
const { string, number, oneOfType, arrayOf } = proptypes;
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';
import {
  EXPERIENCE_TAGS as PROMO_EXPERIENCE_TAGS
} from '@thd-olt-component-react/promotion-products/dist/utils/constants';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import useChoiceBundlePrice from '../hooks/useChoiceBundlePrice';

const ChoiceBundlePrice = ({ skus }) => {
  const [bundlePriceData] = useChoiceBundlePrice(skus);

  if (!bundlePriceData?.graphProduct?.pricing?.value) {
    return (<Placeholder width="100%" height="40px" />);
  }

  return (
    <QueryProvider
      dataSource="catalog"
      cacheKey="choice-price"
      skip={() => true}
    >
      <div className={
        bundlePriceData?.promoType === PROMO_EXPERIENCE_TAGS.BMSM
          ? 'custom-price choice-price bmsm'
          : 'custom-price choice-price'
      }
      >
        <Price
          channel="mobile"
          itemId={bundlePriceData?.anchorSku}
          large={false}
          skip
          displayEachUom={false}
          hideLimitPerOrder
          clsRemediation={{
            placeholders: true,
            preservePlaceholders: true
          }}
          product={bundlePriceData?.graphProduct}
        />
      </div>
    </QueryProvider>
  );
};

ChoiceBundlePrice.propTypes = {
  skus: arrayOf(oneOfType([string, number]))
};

ChoiceBundlePrice.defaultProps = {
  skus: []
};

export default ChoiceBundlePrice;
